import { useContext } from 'react';
import { AsConfigContext } from '../providers/AsConfigProvider';
function useAsCustomerConfigContext() {
    return useContext(AsConfigContext);
}
export default useAsCustomerConfigContext;
